import script from "./pc-video-call-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./pc-video-call-dialog.vue?vue&type=script&setup=true&lang=js"

import "./pc-video-call-dialog.vue?vue&type=style&index=0&id=4c640552&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c640552"]])

export default __exports__